"use strict";

var _objectWithoutProperties = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureDetails = exports.BaseAttributes = exports.Attributes = exports.UriLink = exports.BaseCoreDetails = exports.SimpleValue = exports.BasicValue = exports.FieldName = exports.BaseCard = exports.useStyles = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var react_1 = __importStar(require("react"));
var react_error_boundary_1 = require("react-error-boundary");
var material_1 = require("@mui/material");
var mui_1 = require("tss-react/mui");
var x_data_grid_1 = require("@mui/x-data-grid");
var mobx_react_1 = require("mobx-react");
var is_object_1 = __importDefault(require("is-object"));
// icons
var ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
// locals
var util_1 = require("../util");
var ui_1 = require("../ui");
var SequenceFeatureDetails_1 = __importDefault(require("./SequenceFeatureDetails"));
var util_2 = require("./util");
var MAX_FIELD_NAME_WIDTH = 170;
// these are always omitted as too detailed
var globalOmit = ['__jbrowsefmt', 'length', 'position', 'subfeatures', 'uniqueId', 'exonFrames', 'parentId', 'thickStart', 'thickEnd'];
// coreDetails are omitted in some circumstances
var coreDetails = ['name', 'start', 'end', 'strand', 'refName', 'description', 'type'];
exports.useStyles = (0, mui_1.makeStyles)()(function (theme) {
  var _a;
  return {
    expansionPanelDetails: {
      display: 'block',
      padding: theme.spacing(1)
    },
    expandIcon: {
      color: ((_a = theme.palette.tertiary) === null || _a === void 0 ? void 0 : _a.contrastText) || '#fff'
    },
    field: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    fieldDescription: {
      '&:hover': {
        background: theme.palette.mode === 'dark' ? '#e65100' : 'yellow'
      }
    },
    fieldName: {
      wordBreak: 'break-all',
      minWidth: 90,
      borderBottom: '1px solid #0003',
      fontSize: 12,
      background: theme.palette.action.disabledBackground,
      marginRight: theme.spacing(1),
      padding: theme.spacing(0.5)
    },
    fieldValue: {
      wordBreak: 'break-word',
      maxHeight: 300,
      fontSize: 12,
      padding: theme.spacing(0.5),
      overflow: 'auto'
    },
    fieldSubvalue: {
      wordBreak: 'break-word',
      maxHeight: 300,
      padding: theme.spacing(0.5),
      background: theme.palette.action.disabledBackground,
      border: "1px solid ".concat(theme.palette.action.disabledBackground),
      boxSizing: 'border-box',
      overflow: 'auto'
    }
  };
});
function BaseCard(_ref) {
  var children = _ref.children,
    title = _ref.title,
    _ref$defaultExpanded = _ref.defaultExpanded,
    defaultExpanded = _ref$defaultExpanded === void 0 ? true : _ref$defaultExpanded;
  var _ref2 = (0, exports.useStyles)(),
    classes = _ref2.classes;
  var _ref3 = (0, react_1.useState)(defaultExpanded),
    _ref4 = _slicedToArray(_ref3, 2),
    expanded = _ref4[0],
    setExpanded = _ref4[1];
  return react_1.default.createElement(material_1.Accordion, {
    expanded: expanded,
    onChange: function onChange() {
      return setExpanded(function (s) {
        return !s;
      });
    },
    TransitionProps: {
      unmountOnExit: true,
      timeout: 150
    }
  }, react_1.default.createElement(material_1.AccordionSummary, {
    expandIcon: react_1.default.createElement(ExpandMore_1.default, {
      className: classes.expandIcon
    })
  }, react_1.default.createElement(material_1.Typography, {
    variant: "button"
  }, " ", title)), react_1.default.createElement(material_1.AccordionDetails, {
    className: classes.expansionPanelDetails
  }, children));
}
exports.BaseCard = BaseCard;
var FieldName = function FieldName(_ref5) {
  var description = _ref5.description,
    name = _ref5.name,
    width = _ref5.width,
    _ref5$prefix = _ref5.prefix,
    prefix = _ref5$prefix === void 0 ? [] : _ref5$prefix;
  var _ref6 = (0, exports.useStyles)(),
    classes = _ref6.classes,
    cx = _ref6.cx;
  var val = [].concat(_toConsumableArray(prefix), [name]).join('.');
  return description ? react_1.default.createElement(material_1.Tooltip, {
    title: description,
    placement: "left"
  }, react_1.default.createElement("div", {
    className: cx(classes.fieldDescription, classes.fieldName)
  }, val)) : react_1.default.createElement("div", {
    className: classes.fieldName,
    style: {
      width: width
    }
  }, val);
};
exports.FieldName = FieldName;
var BasicValue = function BasicValue(_ref7) {
  var value = _ref7.value;
  var _ref8 = (0, exports.useStyles)(),
    classes = _ref8.classes;
  var isLink = "".concat(value).match(/^https?:\/\//);
  return react_1.default.createElement("div", {
    className: classes.fieldValue
  }, react_1.default.isValidElement(value) ? value : isLink ? react_1.default.createElement(material_1.Link, {
    href: "".concat(value)
  }, "".concat(value)) : react_1.default.createElement(ui_1.SanitizedHTML, {
    html: (0, is_object_1.default)(value) ? JSON.stringify(value) : String(value)
  }));
};
exports.BasicValue = BasicValue;
function SimpleValue(_ref9) {
  var name = _ref9.name,
    value = _ref9.value,
    description = _ref9.description,
    prefix = _ref9.prefix,
    width = _ref9.width;
  var _ref10 = (0, exports.useStyles)(),
    classes = _ref10.classes;
  return value !== null && value !== undefined ? react_1.default.createElement("div", {
    className: classes.field
  }, react_1.default.createElement(exports.FieldName, {
    prefix: prefix,
    description: description,
    name: name,
    width: width
  }), react_1.default.createElement(exports.BasicValue, {
    value: value
  })) : null;
}
exports.SimpleValue = SimpleValue;
function ArrayValue(_ref11) {
  var name = _ref11.name,
    value = _ref11.value,
    description = _ref11.description,
    _ref11$prefix = _ref11.prefix,
    prefix = _ref11$prefix === void 0 ? [] : _ref11$prefix;
  var _ref12 = (0, exports.useStyles)(),
    classes = _ref12.classes;
  if (value.length === 1) {
    return (0, is_object_1.default)(value[0]) ? react_1.default.createElement(Attributes, {
      attributes: value[0],
      prefix: [].concat(_toConsumableArray(prefix), [name])
    }) : react_1.default.createElement("div", {
      className: classes.field
    }, react_1.default.createElement(exports.FieldName, {
      prefix: prefix,
      description: description,
      name: name
    }), react_1.default.createElement(exports.BasicValue, {
      value: value[0]
    }));
  } else if (value.every(function (val) {
    return (0, is_object_1.default)(val);
  })) {
    return react_1.default.createElement(react_1.default.Fragment, null, value.map(function (val, i) {
      return react_1.default.createElement(Attributes, {
        key: JSON.stringify(val) + '-' + i,
        attributes: val,
        prefix: [].concat(_toConsumableArray(prefix), [name + '-' + i])
      });
    }));
  } else {
    return react_1.default.createElement("div", {
      className: classes.field
    }, react_1.default.createElement(exports.FieldName, {
      prefix: prefix,
      description: description,
      name: name
    }), value.map(function (val, i) {
      return react_1.default.createElement("div", {
        key: JSON.stringify(val) + '-' + i,
        className: classes.fieldSubvalue
      }, react_1.default.createElement(exports.BasicValue, {
        value: val
      }));
    }));
  }
}
var toLocale = function toLocale(n) {
  return n.toLocaleString('en-US');
};
function Position(props) {
  var feature = props.feature;
  var strand = feature.strand;
  var strandMap = {
    '-1': '-',
    '0': '',
    '1': '+'
  };
  var str = strandMap[strand] ? "(".concat(strandMap[strand], ")") : '';
  // @ts-ignore
  var loc = (0, util_1.assembleLocString)(feature);
  return react_1.default.createElement(react_1.default.Fragment, null, "".concat(loc, " ").concat(str));
}
function CoreDetails(props) {
  var feature = props.feature;
  var obj = feature;
  // eslint-disable-next-line no-underscore-dangle
  var formattedFeat = _objectSpread({}, obj, obj.__jbrowsefmt);
  var start = formattedFeat.start,
    end = formattedFeat.end;
  var displayedDetails = _objectSpread({}, formattedFeat, {
    length: toLocale(end - start)
  });
  var coreRenderedDetails = {
    description: 'Description',
    name: 'Name',
    length: 'Length',
    type: 'Type'
  };
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(SimpleValue, {
    name: "Position",
    value: react_1.default.createElement(Position, _objectSpread({}, props, {
      feature: formattedFeat
    }))
  }), Object.entries(coreRenderedDetails).map(function (_ref13) {
    var _ref14 = _slicedToArray(_ref13, 2),
      key = _ref14[0],
      name = _ref14[1];
    return [name, displayedDetails[key]];
  }).filter(function (_ref15) {
    var _ref16 = _slicedToArray(_ref15, 2),
      value = _ref16[1];
    return value != null;
  }).map(function (_ref17) {
    var _ref18 = _slicedToArray(_ref17, 2),
      name = _ref18[0],
      value = _ref18[1];
    return react_1.default.createElement(SimpleValue, {
      key: name,
      name: name,
      value: value
    });
  }));
}
var BaseCoreDetails = function BaseCoreDetails(props) {
  return react_1.default.createElement(BaseCard, _objectSpread({}, props, {
    title: "Primary data"
  }), react_1.default.createElement(CoreDetails, _objectSpread({}, props)));
};
exports.BaseCoreDetails = BaseCoreDetails;
function UriLink(_ref19) {
  var value = _ref19.value;
  var href = (0, util_1.getUriLink)(value);
  return react_1.default.createElement(ui_1.SanitizedHTML, {
    html: "<a href=\"".concat(href, "\">").concat(href, "</a>")
  });
}
exports.UriLink = UriLink;
function DataGridDetails(_ref20) {
  var value = _ref20.value,
    prefix = _ref20.prefix,
    name = _ref20.name;
  var keys = Object.keys(value[0]).sort();
  var unionKeys = new Set(keys);
  value.forEach(function (val) {
    return Object.keys(val).forEach(function (k) {
      return unionKeys.add(k);
    });
  });
  if (unionKeys.size < keys.length + 5) {
    // avoids key 'id' from being used in row data
    var rows = Object.entries(value).map(function (_ref21) {
      var _ref22 = _slicedToArray(_ref21, 2),
        k = _ref22[0],
        val = _ref22[1];
      var id = val.id,
        rest = _objectWithoutProperties(val, ["id"]);
      return _objectSpread({
        id: k,
        identifier: id
      }, rest);
    });
    // avoids key 'id' from being used in column names, and tries
    // to make it at the start of the colNames array
    var colNames;
    if (unionKeys.has('id')) {
      unionKeys.delete('id');
      colNames = ['identifier'].concat(_toConsumableArray(unionKeys));
    } else {
      colNames = _toConsumableArray(unionKeys);
    }
    var columns = colNames.map(function (val) {
      return {
        field: val,
        renderCell: function renderCell(params) {
          var value = params.value;
          return (0, util_1.isUriLocation)(value) ? react_1.default.createElement(UriLink, {
            value: value
          }) : (0, util_1.getStr)(value);
        },
        width: (0, util_1.measureGridWidth)(rows.map(function (r) {
          return r[val];
        }))
      };
    });
    var rowHeight = 25;
    var hideFoot = rows.length < 100;
    var headHeight = 80;
    var height = Math.min(rows.length, 100) * rowHeight + headHeight + (hideFoot ? 0 : 50);
    // disableSelection on click helps avoid
    // https://github.com/mui-org/material-ui-x/issues/1197
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(exports.FieldName, {
      prefix: prefix,
      name: name
    }), react_1.default.createElement("div", {
      style: {
        height: height,
        width: '100%'
      }
    }, react_1.default.createElement(x_data_grid_1.DataGrid, {
      disableSelectionOnClick: true,
      rowHeight: rowHeight,
      rows: rows,
      hideFooterSelectedRowCount: true,
      columns: columns,
      hideFooter: hideFoot
    })));
  }
  return null;
}
// pick using a path from an object, similar to _.get from lodash with special logic
// for Descriptions from e.g. VCF headers
// @param arr  example ['a','b'], obj = {a:{b:'hello}}
// @returns hello (with special addition to grab description also)
function accessNested(arr) {
  var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  arr.forEach(function (elt) {
    if (obj) {
      obj = obj[elt];
    }
  });
  return typeof obj === 'string' ? obj : typeof (obj === null || obj === void 0 ? void 0 : obj.Description) === 'string' ? obj.Description : undefined;
}
function generateMaxWidth(array, prefix) {
  var arr = [];
  array.forEach(function (key) {
    var val = [].concat(_toConsumableArray(prefix), [key[0]]).join('.');
    arr.push((0, util_1.measureText)(val, 12));
  });
  return Math.ceil(Math.max.apply(Math, arr)) + 10;
}
function UriAttribute(_ref23) {
  var value = _ref23.value,
    prefix = _ref23.prefix,
    name = _ref23.name;
  var _ref24 = (0, exports.useStyles)(),
    classes = _ref24.classes;
  var uri = value.uri,
    _value$baseUri = value.baseUri,
    baseUri = _value$baseUri === void 0 ? '' : _value$baseUri;
  var href;
  try {
    href = new URL(uri, baseUri).href;
  } catch (e) {
    href = uri;
  }
  return react_1.default.createElement("div", {
    className: classes.field
  }, react_1.default.createElement(exports.FieldName, {
    prefix: prefix,
    name: name
  }), react_1.default.createElement(exports.BasicValue, {
    value: href
  }));
}
function Attributes(props) {
  var attributes = props.attributes,
    _props$omit = props.omit,
    omit = _props$omit === void 0 ? [] : _props$omit,
    _props$omitSingleLeve = props.omitSingleLevel,
    omitSingleLevel = _props$omitSingleLeve === void 0 ? [] : _props$omitSingleLeve,
    descriptions = props.descriptions,
    _props$formatter = props.formatter,
    formatter = _props$formatter === void 0 ? function (val) {
      return val;
    } : _props$formatter,
    hideUris = props.hideUris,
    _props$prefix = props.prefix,
    prefix = _props$prefix === void 0 ? [] : _props$prefix;
  var omits = [].concat(_toConsumableArray(omit), globalOmit, _toConsumableArray(omitSingleLevel));
  var __jbrowsefmt = attributes.__jbrowsefmt,
    rest = _objectWithoutProperties(attributes, ["__jbrowsefmt"]);
  var formattedAttributes = _objectSpread({}, rest, __jbrowsefmt);
  var maxLabelWidth = generateMaxWidth(Object.entries(formattedAttributes).filter(function (_ref25) {
    var _ref26 = _slicedToArray(_ref25, 2),
      k = _ref26[0],
      v = _ref26[1];
    return v !== undefined && !omits.includes(k);
  }), prefix);
  return react_1.default.createElement(react_1.default.Fragment, null, Object.entries(formattedAttributes).filter(function (_ref27) {
    var _ref28 = _slicedToArray(_ref27, 2),
      k = _ref28[0],
      v = _ref28[1];
    return v !== undefined && !omits.includes(k);
  }).map(function (_ref29) {
    var _ref30 = _slicedToArray(_ref29, 2),
      key = _ref30[0],
      value = _ref30[1];
    var description = accessNested([].concat(_toConsumableArray(prefix), [key]), descriptions);
    if (Array.isArray(value)) {
      // check if it looks like an array of objects, which could be used
      // in data grid
      return value.length > 1 && value.every(function (val) {
        return (0, is_object_1.default)(val);
      }) ? react_1.default.createElement(DataGridDetails, {
        key: key,
        name: key,
        prefix: prefix,
        value: value
      }) : react_1.default.createElement(ArrayValue, {
        key: key,
        name: key,
        value: value,
        description: description,
        prefix: prefix
      });
    } else if ((0, is_object_1.default)(value)) {
      var _omitSingleLevel = props.omitSingleLevel,
        _rest = _objectWithoutProperties(props, ["omitSingleLevel"]);
      return (0, util_1.isUriLocation)(value) ? hideUris ? null : react_1.default.createElement(UriAttribute, {
        key: key,
        name: key,
        prefix: prefix,
        value: value
      }) : react_1.default.createElement(Attributes, _objectSpread({}, _rest, {
        key: key,
        attributes: value,
        descriptions: descriptions,
        prefix: [].concat(_toConsumableArray(prefix), [key])
      }));
    } else {
      return react_1.default.createElement(SimpleValue, {
        key: key,
        name: key,
        value: formatter(value, key),
        description: description,
        prefix: prefix,
        width: Math.min(maxLabelWidth, MAX_FIELD_NAME_WIDTH)
      });
    }
  }));
}
exports.Attributes = Attributes;
var BaseAttributes = function BaseAttributes(props) {
  var feature = props.feature;
  return react_1.default.createElement(BaseCard, _objectSpread({}, props, {
    title: "Attributes"
  }), react_1.default.createElement(Attributes, _objectSpread({}, props, {
    attributes: feature
  })));
};
exports.BaseAttributes = BaseAttributes;
function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function generateTitle(name, id, type) {
  return [(0, util_2.ellipses)("".concat(name) || "".concat(id)), "".concat(type)].filter(function (f) {
    return !!f;
  }).join(' - ');
}
function FeatureDetails(props) {
  var _props$omit2 = props.omit,
    omit = _props$omit2 === void 0 ? [] : _props$omit2,
    model = props.model,
    feature = props.feature,
    _props$depth = props.depth,
    depth = _props$depth === void 0 ? 0 : _props$depth;
  var _feature$name = feature.name,
    name = _feature$name === void 0 ? '' : _feature$name,
    _feature$id = feature.id,
    id = _feature$id === void 0 ? '' : _feature$id,
    _feature$type = feature.type,
    type = _feature$type === void 0 ? '' : _feature$type,
    subfeatures = feature.subfeatures;
  var pm = (0, util_1.getEnv)(model).pluginManager;
  var session = (0, util_1.getSession)(model);
  var ExtraPanel = pm.evaluateExtensionPoint('Core-extraFeaturePanel', null, {
    session: session,
    feature: feature,
    model: model
  });
  return react_1.default.createElement(BaseCard, {
    title: generateTitle(name, id, type)
  }, react_1.default.createElement(material_1.Typography, null, "Core details"), react_1.default.createElement(CoreDetails, _objectSpread({}, props)), feature.mate ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(material_1.Divider, null), react_1.default.createElement(material_1.Typography, null, "Mate details"), react_1.default.createElement(CoreDetails, _objectSpread({}, props, {
    feature: feature.mate
  }))) : null, react_1.default.createElement(material_1.Divider, null), react_1.default.createElement(material_1.Typography, null, "Attributes"), react_1.default.createElement(Attributes, _objectSpread({
    attributes: feature
  }, props, {
    omit: omit,
    omitSingleLevel: coreDetails
  })), react_1.default.createElement(react_error_boundary_1.ErrorBoundary, {
    FallbackComponent: function FallbackComponent(_ref31) {
      var error = _ref31.error;
      return react_1.default.createElement(ui_1.ErrorMessage, {
        error: error
      });
    }
  }, react_1.default.createElement(SequenceFeatureDetails_1.default, _objectSpread({}, props))), ExtraPanel ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(material_1.Divider, null), react_1.default.createElement(BaseCard, {
    title: ExtraPanel.name
  }, react_1.default.createElement(ExtraPanel.Component, _objectSpread({}, props)))) : null, (subfeatures === null || subfeatures === void 0 ? void 0 : subfeatures.length) ? react_1.default.createElement(BaseCard, {
    title: "Subfeatures",
    defaultExpanded: depth < 1
  }, subfeatures.map(function (sub) {
    return react_1.default.createElement(FeatureDetails, {
      key: JSON.stringify(sub),
      feature: sub,
      model: model,
      depth: depth + 1
    });
  })) : null);
}
exports.FeatureDetails = FeatureDetails;
exports.default = (0, mobx_react_1.observer)(function (_ref32) {
  var model = _ref32.model;
  var featureData = model.featureData;
  if (!featureData) {
    return null;
  }
  // replacing undefined with null helps with allowing fields to be hidden,
  // setting null is not allowed by jexl so we set it to undefined to hide. see
  // config guide. this replacement happens both here and when snapshotting the
  // featureData
  var g = JSON.parse(JSON.stringify(featureData, function (_, v) {
    return typeof v === 'undefined' ? null : v;
  }));
  return isEmpty(g) ? null : react_1.default.createElement(FeatureDetails, {
    model: model,
    feature: g
  });
});